<template>
    <v-container id="login" fill-height tag="section">
        <v-row justify="center">
            <v-slide-y-transition appear>
                <base-material-card color="primary" light max-width="100%" width="400" class="px-5 py-3">
                    <template v-slot:heading>
                        <div class="text-center">
                            <h1 class="display-2 font-weight-bold mb-2">
                                SC<sup>2</sup> - Hotels - Login {{ getIdUser }}
                            </h1>

                            <v-btn v-for="(social, i) in socials" :key="i" class="ma-1" icon rel="noopener" target="_blank"><!--  :href="social.href" -->
                                <v-icon v-text="social.icon" :disabled="social.disabled" />
                            </v-btn>
                        </div>
                    </template>

                    <v-card-text class="text-center">
                        <div class="text-center grey--text body-1 font-weight-light">
                            'Discover the World'
                        </div>

                        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
                            <v-text-field
                                v-model="username"
                                :rules="[rules.required, rules.min]"
                                label="User Name.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-face"
                                color="secondary"
                                class="mt-10">
                            </v-text-field>

                            <v-text-field
                                v-model="password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show1 ? 'text' : 'password'"
                                label="Password.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-lock-outline"
                                counter
                                color="secondary"
                                class="mt-10"
                                @click:append="show1 = !show1">
                            </v-text-field>

                            <pages-btn color="primary" :rounded="false" class="v-btn--text" :disabled="!valid" @click="onValidate" style="color: #ffffff; margin-top:30px; margin-bottom:20px;" width="50%">
                                Let's Go
                            </pages-btn>
                        </v-form>
                    </v-card-text>
                </base-material-card>
            </v-slide-y-transition>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';


    export default {
        name: 'PagesLogin',

        /* >>> *************************************************************** / /* Components */
        components: {

            PagesBtn: () => import('./components/Btn')

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            valid: false,
            // username: 'Learek',
            // password: 'broeker29',
            username: '',
            password: '',
            show1: false,
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 3 || 'Min 3 characters',
                emailMatch: () => ('The email and password you entered don\'t match')
            },
            // >>> ------------------------------
            socials: [
                {
                    href: '#',
                    icon: 'mdi-airplane-takeoff',    // flights
                    disabled: true,
                },
                {
                    href: '#',
                    icon: 'mdi-calendar-account',   // calendar
                    disabled: true,
                },
                {
                    href: '#',
                    icon: 'mdi-clipboard-list',     // dutyplan
                    disabled: true,
                },
                {
                    href: '#',
                    icon: 'mdi-account-multiple',   // people
                    disabled: true,

                },
                {
                    href: '#',
                    icon: 'mdi-bed',                 // hotels
                    disabled: false,
                },
                {
                    href: '#',
                    icon: 'mdi-beach',              // vacations
                    disabled: true,
                },
            ]

        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getIdUser' // This is tmp only
            ])

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
		created: function () {

            let me = this;


            me.$toc('>>> views/pages/Login.vue >>> created');

		}, // eof created()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_userLogin'
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate()
            *
            * Desc: Check if Form is valid. If so ... Login.
            * Note:
            *
            */
            onValidate: function() {

                let me = this;


                me.$toc('>>> views/pages/Login.vue >>> onValidate');
                if (this.$refs.form.validate()) {
                    const params = {
                        username: this.username,
                        password: this.password
                    };
                    this.actn_userLogin(params);
                }

            }, // eof onValidate()

            /*******************************************************************
            * reset()
            *
            * Desc: Reset Form.
            * Note: Still unused.
            *
            */
            reset: function() {

                this.$refs.form.reset();

            }, // eof reset()

            /*******************************************************************
            * resetValidation()
            *
            * Desc: Reset Forms Validations.
            * Note: Still unused.
            *
            */
            resetValidation: function() {

                this.$refs.form.resetValidation();

            } // eof resetValidation()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset;
        -moz-box-shadow: 0 0 0 100px #fff inset;
        box-shadow: 0 0 0 100px #fff inset;
        /* change the white to any color */
    }
</style>

